module.exports = __webpack_public_path__ + "static/media/intergalactic-team.45d05665.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/careers/intergalactic-team.svg
// module id = 1297
// module chunks = 0